import React from "react";
import Layout from "../../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Tooltip,
  Paper,
  Checkbox,
  ButtonGroup,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import MuiAlert from "@material-ui/lab/Alert";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import googleAnalytics from "fuction/googleAnalytics";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  noGroup: {
    color: "rgb(220, 0, 78)",
  },
  table: {
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  emailCell: {
    width: "300px",
  },
  buttonCol: {
    textAlign: "center",
    width: "170px",
  },
  emailInput: {
    width: "250px",
  },
  submit: {
    marginTop: theme.spacing(3),
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
}));

export default function DailyTopicMail(props) {
  const classes = useStyles();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();

  const [recipients, setRecipients] = React.useState([]);
  const [email, setEmail] = React.useState("");
  const [groups, setGroups] = React.useState([]);
  const [selectGroups, setSelectGroups] = React.useState([]);
  const [enableGroupCount, setEnableGroupCount] = React.useState(0);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);

  const [operation, setOperation] = React.useState(null);
  const [isSuccess, setIsSuccess] = React.useState(false);

  const { request } = useApi();
  const { state } = useAuth();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - デイリートピックメール送付先設定";
    
    stateError.initialize();
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchRecipients();
  }, [auth.state.token]);

  React.useEffect(() => {
    if (!state.groups) {
      return;
    }
    
    // 掲載可能グループをカウント
    let groupCount = 0;
    state.groups.map((group) => {
      if (group.dtm_enable) {
        groupCount++;
      }
    });
    setEnableGroupCount(groupCount);
  }, [state.groups]);

  const fetchRecipients = () => {
    request({
      method: "GET",
      url: `config/:account_id/dtm_recipients`,
    }).then((result) => {
      setRecipients(result.data);
    });
  };

  // 収集グループのチェックボックス制御
  const dtmGroupChange = (event, index) => {
    const groupId = Number(event.target.name);
    let editRecipient = [...recipients];
    if (recipients[index-1].groups.find(item => item == groupId)) {
      editRecipient[index-1].groups = 
        editRecipient[index-1].groups.filter(item => item != Number(event.target.name));
    } else {
      editRecipient[index-1].groups = 
        [...editRecipient[index-1].groups, Number(event.target.name)];
    }
    setRecipients(editRecipient);
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell className={classes.emailCell}>{row.email}</TableCell>
          {state.groups.map((group) => {
            return (
              <TableCell align="center">
                <Checkbox 
                  checked={row.groups.find(item => item == group.id)}
                  onChange={(event) => dtmGroupChange(event, index)} 
                  name={group.id}
                  disabled={!group.dtm_enable}
                />
              </TableCell>
            )
          })}
          <TableCell>
            <ButtonGroup variant="contained" color="primary">
              <Button
                onClick={() => editDtm(index)}
                disabled={enableGroupCount == 0}
              >
                更新
              </Button>
              <Button
                color="secondary"
                onClick={() => openDialog(row.id)}
              >
                削除
              </Button>
            </ButtonGroup>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  // 新規DTM登録に紐づく収集グループのチェックボックス制御
  const newDtmGroupChange = (event) => {
    if (event.target.checked) {
      // チェックを付けた値を追加
      setSelectGroups([ ...selectGroups, Number(event.target.name)]);
    } else {
      // チェックを外した値を削除
      setSelectGroups(selectGroups.filter(item => item != Number(event.target.name)));
    }
  };

  // DTM登録
  const registerDtm = () => {
    setIsSuccess(false);

    request({
      method: "POST",
      url: `config/:account_id/dtm_recipients`,
      data: {
        email: email,
        groups: selectGroups,
      },
    })
      .then((result) => {
        stateError.initialize();
        setEmail("");
        fetchRecipients();
        setIsSuccess(true);
        setOperation("登録");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  // DTM更新
  const editDtm = (index = null) => {
    setIsSuccess(false);

    let targetDtm = [];
    if (index) {
      // indexがあれば単体更新
      targetDtm = [
        {
          email: recipients[index-1].email,
          groups: recipients[index-1].groups,
        }
      ];
    } else {
      // indexが無ければ一括更新
      targetDtm = recipients.map(recipient => {
        return {
          email: recipient.email,
          groups: recipient.groups,
        }
      });
    }

    request({
      method: "PUT",
      url: `config/:account_id/dtm_recipients`,
      data: {
        dtm_rcpts: targetDtm,
      },
    })
      .then((result) => {
        stateError.initialize();
        fetchRecipients();
        setIsSuccess(true);
        setOperation("更新");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  const openDialog = (id, date) => {
    setDeleteId(id);
    setIsShowModal(true);
  };

  // DTM削除
  const deleteDtm = () => {
    setIsSuccess(false);

    request({
      method: "DELETE",
      url: `config/:account_id/dtm_recipients/${deleteId}`,
    })
      .then((result) => {
        stateError.initialize();
        fetchRecipients();
        setIsShowModal(false);
        setIsSuccess(true);
        setOperation("削除");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  const onError = () => {
    setIsSuccess(false);
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Grid item>
                <Typography variant="h6" color="primary">
                  デイリートピックメール
                </Typography>
                <Typography variant="p">
                  ※デイリートピックメールは、最大10件まで登録できます。
                </Typography>
                {enableGroupCount == 0 && (
                    <Typography variant="p" display="block" className={classes.noGroup}>
                      掲載可能な収集グループがありません。
                    </Typography>
                  )
                }
              </Grid>
              <Grid container>
                <ValidatorForm
                  onSubmit={(e) => {
                    e.preventDefault();
                    registerDtm();
                  }}
                  onError={onError}
                >
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>メールアドレス</TableCell>
                        {state.groups.map((group) => {
                          return (
                            <TableCell>
                              <Tooltip title={group.name}>
                                <Typography>
                                  {(group.name).length > 6 ? (group.name).slice(0,6) + "..." : group.name}
                                </Typography>
                              </Tooltip>
                            </TableCell>
                          )
                        })}
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {recipients.map(
                        function (row, index) {
                          return <Row index={index+1} row={row} />
                        }
                      )}
                      {recipients.length < 10 && (
                        <TableRow>
                          <TableCell>
                            <TextValidator
                              label="メールアドレス*"
                              className={classes.emailInput}
                              value={email}
                              onChange={(event) => setEmail(event.target.value)}
                              name="email"
                              type="email"
                              validators={['required', 'isEmail']}
                              errorMessages={[
                                messages.validation.required, 
                                messages.validation.emailRegexp, 
                              ]}
                            />
                          </TableCell>
                          {state.groups.map((group) => {
                            return (
                              <TableCell align="center">
                                <Checkbox 
                                  onChange={newDtmGroupChange} 
                                  name={group.id}
                                  disabled={!group.dtm_enable}
                                />
                              </TableCell>
                            )
                          })}
                          <TableCell className={classes.buttonCol}>
                            <Button
                              type="submit"
                              variant="contained"
                              color="primary"
                            >
                              追加
                            </Button>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>  
                </ValidatorForm>
              </Grid>
            </Paper>
            {isSuccess && (
              <div className={classes.messsageWrapper}>
                <MuiAlert elevation={6} variant="filled" severity="success">
                  {operation}が完了しました
                </MuiAlert>
              </div>
            )}
            {stateError.state.isError && (
              <div className={classes.messsageWrapper}>
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  severity="error"
                  className={classes.toast}
                >
                  {stateError.state.errorMsg}
                </MuiAlert>
              </div>
            )}
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              className={classes.submit}
            >
              <Button
                variant="contained"
                size="medium"
                color="primary"
                onClick={() => editDtm()}
                disabled={enableGroupCount == 0}
              >
                一括更新
              </Button>
            </Grid>
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={() => deleteDtm()}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}
